var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5cee0",
    d: "M21.16 10.884c.154-.406.24-.85.24-1.313 0-2.01-1.612-3.642-3.6-3.642-.739 0-1.429.227-1.999.614C14.762 4.722 12.824 3.5 10.6 3.5c-3.315 0-6 2.717-6 6.071 0 .103.004.205.007.308A5.463 5.463 0 001 15.036C1 18.052 3.419 20.5 6.4 20.5h13.8c2.651 0 4.8-2.174 4.8-4.857 0-2.349-1.65-4.31-3.84-4.759zm-5.246 2.418l-.405.41a.896.896 0 01-1.294-.02L13 12.383v4.778c0 .504-.401.91-.9.91h-.6a.903.903 0 01-.9-.91v-4.778l-1.215 1.31a.893.893 0 01-1.294.018l-.405-.41a.915.915 0 010-1.286l3.476-3.517a.89.89 0 011.272 0l3.476 3.517a.92.92 0 01.004 1.287z"
  }))));
}

export default SvgCloudUpload;